var map = {
	"./112.png": 962,
	"./gaivinimas.png": 455,
	"./iskaba.png": 253,
	"./pagalba.png": 647,
	"./pavojai.png": 693,
	"./saugumas.png": 324,
	"./savipagalba.png": 787,
	"./sveikata.png": 611,
	"./taisykles.png": 63,
	"./valtyje.png": 419,
	"./veliava.png": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;